import { useFilter } from "hooks/filter";
import { Icon } from "components/ui";
import { IconName } from "@fortawesome/fontawesome-common-types";
import { ContentCategory } from "types/appConfigV2";
import {
  Box,
  Grid,
  Typography,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
} from "@mui/material";

export default function Header(props: {
  categories: { [key: string]: ContentCategory };
}) {
  const { searchDispatch, searchState } = useFilter();

  return (
    <Box mb={2} sx={{ flexGrow: 1 }}>
      <Grid
        alignItems="center"
        justifyContent="space-between"
        container
        spacing={2}
      >
        <Grid item>
          <Typography variant="h6">
            {searchState.currentCategory.title}
          </Typography>
        </Grid>
        <Grid item>
          <ToggleButtonGroup
            color="primary"
            exclusive={true}
            size="small"
            onChange={(event: React.MouseEvent<HTMLElement>, category: any) => {
              if (category !== null) {
                searchDispatch({
                  type: "CHANGE_CATEGORY",
                  payload: category,
                });
              }
            }}
          >
            {Object.entries(props.categories).map((entry) => (
              <Tooltip title={entry[1].title} key={entry[1].id}>
                <ToggleButton
                  key={entry[1].id}
                  disableRipple
                  value={entry[1]}
                  selected={searchState.currentCategory.id === entry[1].id}
                >
                  <Icon name={entry[1].icon as IconName} />
                </ToggleButton>
              </Tooltip>
            ))}
          </ToggleButtonGroup>
        </Grid>
      </Grid>
    </Box>
  );
}
